let Vuex = null
export const setCocosUtilsVuex = a => {
    Vuex = a;
    return Vuex;
};
// cocos所有课件对应的配置
// @params data表示【this.$store.state.menusData】
export function cocosConfig({data, ids}) {
    let newConfig = []
    try {
        newConfig = data.blocksForm.map(v=>{
            let lesson = []
            let obj = {
                ...v,
                scene: v.name
            }
            // 判断菜单项是否有效
            if(v.children && v.children.length>0) {
                v.children.map((q, i) => {
                    if(typeof q === 'object') q.disabled = getStatus(q, ids)
                    if(ids) {
                        v.children[i] = ids[q.unique]
                    }
                })
                lesson = v.children
                // lesson = lesson.filter(v=>!v.disabled)
            }
            obj.lesson = lesson
            if(v.leaf && v.leaf.length>0){
                obj.leaf = getNewLeaf({data:v.leaf, ids})
            }
            return obj
        })

        // 将newConfig 转成 [{scene:xx, lesson: [], leaf: [{scene:xx, lesson: [], leaf: []}]}]
        newConfig = loopFormat({data: newConfig})
    }catch (e) {
        console.log('获取失败cocos所有配置==>', e)
    }
    return newConfig
}

// 获取是否禁用状态
export function getStatus(item, ids){
    let state = false
    if (['game', 'tools'].includes(item.type)) {
        const type = Vuex.state.curClassType
        if(ids) {
            switch (type) {
                case 'online':
                    state = !ids[item.unique].config.is_online
                    if (`${ids[item.unique].config.is_online}` === `undefined`) state = false
                    break
                case 'offline':
                    state = !ids[item.unique].config.is_offline
                    if (`${ids[item.unique].config.is_offline}` === `undefined`) state = false
                    break
                case 'double_teacher':
                    state = !ids[item.unique].config.is_double_teacher
                    if (`${ids[item.unique].config.is_double_teacher}` === `undefined`) state = false
                    break
            }
        }
    }
    return state
}
export function getNewLeaf({data, ids}){
    data.map(v=>{
        let lesson = []
        // 判断菜单项是否有效
        if(v.children && v.children.length>0) {
            v.children.map((q, i) => {
                if(typeof q === 'object') q.disabled = getStatus(q)
                if(ids) v.children[i] = ids[q.unique]
            })
            lesson = v.children
            // lesson = lesson.filter(v=>!v.disabled)
        }
        v.lesson = lesson
        v.scene = v.name
        if(v.leaf && v.leaf.length>0){
            v.leaf = getNewLeaf({data:v.leaf, ids})
        }
    })
    return data
}
// 将newConfig 转成 [{scene:xx, lesson: [], leaf: [{scene:xx, lesson: [], leaf: []}]}]
export function loopFormat({data}){
    let obj = {}
    return data.map(v => {
        obj = {
            scene: v.scene,
            lesson: v.lesson
        }
        if (v.leaf && v.leaf.length > 0) {
            obj.leaf = getNewChilrens({data:v.leaf})
        }
        return obj
    })
}
export function getNewChilrens ({data}) {
    let obj = {}
    return data.map(v => {
        obj = {
            scene: v.scene,
            lesson: v.lesson
        }
        if (v.leaf && v.leaf.length > 0) {
            obj.leaf = getNewChilrens({data:v.leaf})
        }
        return obj
    })
}
